export default function ChevronCompactLeftIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.3652 16.8882L8.09082 11.2852C7.99674 11.0638 7.91097 10.8452 7.8335 10.6294C7.76156 10.408 7.72559 10.195 7.72559 9.99023C7.72559 9.77995 7.76156 9.56689 7.8335 9.35107C7.91097 9.12972 7.99674 8.90837 8.09082 8.68701L10.3652 3.08398C10.4427 2.90137 10.5562 2.75472 10.7056 2.64404C10.8605 2.53337 11.0293 2.47803 11.2119 2.47803C11.5218 2.47803 11.7736 2.57487 11.9673 2.76855C12.1665 2.96224 12.2661 3.2002 12.2661 3.48242C12.2661 3.63184 12.2329 3.79785 12.1665 3.98047C12.1001 4.15755 12.0337 4.31527 11.9673 4.45361L9.51855 10.5215V9.45898L11.9673 15.5186C12.0337 15.6624 12.1001 15.8229 12.1665 16C12.2329 16.1771 12.2661 16.3403 12.2661 16.4897C12.2661 16.772 12.1665 17.0099 11.9673 17.2036C11.7736 17.4028 11.5218 17.5024 11.2119 17.5024C11.0293 17.5024 10.8605 17.4443 10.7056 17.3281C10.5562 17.2174 10.4427 17.0708 10.3652 16.8882Z" />
    </svg>
  );
}
